import { useEffect, useState } from 'react'

/** Пауза по умолчанию, мс. */
const DEFAULT_DELAY_MS = 300

/**
 * Значение с задержкой: фильтр, набранный по буквам, уходит запросом, когда
 * человек перестал печатать, а не на каждую клавишу (CLAUDE.md §7).
 */
export function useDebouncedValue<T>(value: T, delayMs = DEFAULT_DELAY_MS): T {
  const [settled, setSettled] = useState(value)
  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs)
    return () => clearTimeout(timer)
  }, [value, delayMs])
  return settled
}
